export const REACT_APP_ENV = process.env.REACT_APP_ENV ?? 'dev';
export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ??
  'https://dev-api.admission.codestates.xyz/api/';
export const DTLAB_IMAGE_UPLOADER_API_URL =
  process.env.REACT_APP_DTLAB_IMAGE_UPLOADER_API_URL ?? '';
export const DTLAB_IMAGE_UPLOADER_API_KEY =
  process.env.REACT_APP_DTLAB_IMAGE_UPLOADER_API_KEY ?? '';
